import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { UniAbcState } from "./state";

const defaultState: UniAbcState = {
  entries: {},
  lastLoad: new Date(0),
  fileLastCommitId: ""
};

export const uniAbcModule = {
  state: defaultState,
  mutations,
  actions,
  getters
};
